'use strict';

export default class CustomYearFilter {
  constructor($selector, selfInit = true) {
    const $yearFilter = $('.custom-year-filter', $selector);

    this.isShown = false;
    this.selectedOption = {};
    let $triggerButton = $('.custom-trigger', $selector);
    let $triggerLabel = $('.label', $triggerButton);
    let $yearRangeWrapper = $('.custom-year-filter__year-range', $selector);
    this.$selector = $selector;
    this.$yearFilter = $yearFilter;
    this.$customDropdown = $('.custom-year-filter__dropdown', $selector);
    this.currentYearType = 'all';

    $triggerButton.on('click', e => {
      e.preventDefault();

      if (this.isShown) {
        this.hideList();
      } else {
        window.emitter.emit('selectOpened', $selector);
        this.showList();
      }
    });

    //to close the dropdown when other is being opened
    window.emitter.on('selectOpened', ($openedSelector) => {
      if ($selector != $openedSelector) {
        this.hideList();
      }
    });

    $(document).on('click.customFilter', e => {
      let $eTarget = $(e.target);

      if (!$eTarget.hasClass('custom-year-filter__dropdown') && !$eTarget.parents('.custom-year-filter__dropdown').length) {
        this.hideList();
      }
    });

    this.$yearTypeOptions = $('.custom-year-filter__options');
    $('.radio', this.$yearTypeOptions).map((i, ele) => {
      $(ele).on('click.customyeartype', () => {
        let selectedYearType = $(ele).val();
        this.toggleYearFilter(selectedYearType);

        if (selectedYearType == 'all') {
          $triggerLabel.text($(ele).next('label').text());
          this.hideList();
        }
      });
    });

    $('.radio--label-only', this.$selector).map((i, ele) => {
      $(ele).on('click.customyearoption', () => {
        $triggerLabel.text($(ele).next('label').text());
        this.hideList();

        $('input[type="text"]', $yearRangeWrapper).val('');
      });
    });
    
    //Configure year-type display with its filter on load
    this.toggleYearFilter($('input[type="radio"]:checked', this.$yearTypeOptions).val());
  }

  showList() {
    this.isShown = true;
    this.$customDropdown.addClass('list-shown');
    this.$selector.addClass('selecting');
  }

  hideList() {
    this.isShown = false;
    this.$customDropdown.removeClass('list-shown');
    this.$selector.removeClass('selecting');
  }

  toggleYearFilter(selectedYearType) {
    if (selectedYearType !== 'all') {
      $('.custom-year-filter__filters').addClass('showing');
    } else {
      $('.custom-year-filter__filters').removeClass('showing');
    }
    if (selectedYearType !== this.currentYearType) {
      // Hide the currently visible .custom-year-filter__filter div
      $('.custom-year-filter__filters .custom-year-filter__filter').fadeOut(300);

      $('.custom-year-filter__filters .custom-year-filter__filter[data-year-type="' + selectedYearType + '"]').fadeIn(300);
      this.currentYearType = selectedYearType;
    }
  }
}
